// File: MobileAppAboutSection.jsx
// Usage: paste into a React app (CRA/Vite). Pure CSS, no libraries.
// Uses local uploaded screenshot for the CTA background: /mnt/data/Screenshot 2025-11-16 151537.png

import { Building2, Home, Locate } from 'lucide-react';
import React from 'react';
export default function AboutUsCard5() {
  return (<>
    <div className="ma-section">
      <div className="ma-header">
        <h2>How It Works</h2>
        <div className="ma-underline" />
        <p className="ma-lead"></p>
      </div>

      <div className="ma-feat-ac-5ures">
        <div className="feat-ac-5">
          <div className="icon-ac-5"><Home size={30} color={"#222222"}/></div>
          <h3>Step 1
</h3>
          <p className="muted-ac-5">
Choose Your Test</p>
          <a className="readmore-ac-5">
Select chapter-wise or full-length mock tests.↗</a>
        </div>

        <div className="feat-ac-5">
          <div className="icon-ac-5"><Building2 size={30} color={"#222222"}/></div>
          <h3>🔹 Step 2
</h3>
          <p className="muted-ac-5">
Attempt Test Online.</p>
          <a className="readmore-ac-5">
Timed environment similar to real Online exam. ↗</a>
        </div>

        <div className="feat-ac-5">
          <div className="icon-ac-5"><Locate size={30} color={"#222222"}/></div>
          <h3>Step 3
</h3>
          <p className="muted-ac-5">
Analyze Performance</p>
          <a className="readmore-ac-5">Check score, accuracy, get analysis pdf and improve weak areas. ↗</a>
        </div>
      </div>

     
    </div>
    <style>{`
/* File: MobileAppAboutSection.css */

:root{
  --accent:rgba(144, 202, 249,1); /* coral */
  --dark:rgba(144, 202, 249,1);
  --muted-ac-5:#8b8b8b;
}

.ma-section{margin-top:50px;background:#fff; padding:60px 40px; font-family:Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial}

.ma-header{text-align:center; max-width:900px; margin:0 auto 40px}
.ma-header h2{font-size:34px; margin:0; color:#222222; font-weight:800}
.ma-underline{width:60px; height:6px; background:var(--accent); margin:14px auto}
.ma-lead{color:var(--muted-ac-5); margin-top:18px; line-height:1.7}

.ma-feat-ac-5ures{display:flex; gap:30px; justify-content:center; margin:50px 0}
.feat-ac-5{flex:1; max-width:320px; text-align:center}
.icon-ac-5{width:78px; height:78px; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 18px; font-size:30px; color:var(--accent); border:2px solid rgba(144, 202, 249,0.2); background:rgba(144, 202, 249,0.31);}
.feat-ac-5 h3{font-size:18px; margin:6px 0; color:var(--dark); font-weight:700}
.muted-ac-5{color:var(--muted-ac-5); font-size:14px}
.readmore-ac-5{display:inline-block; margin-top:12px; color:var(--muted-ac-5); font-weight:600; cursor:pointer}

/* CTA Banner */
.ma-cta{margin-top:40px; border-radius:8px; overflow:hidden; display:flex; align-items:center; justify-content:space-between; padding:32px; background:rgba(144, 202, 249,0.61);}
.ma-cta-inner h3{color:#222222; font-size:26px; margin:0 0 10px; font-weight:800}
.ma-cta .muted-ac-5{color:#222222}
.ma-cta-btn{background:#ffffff; border:2px solid rgba(144, 202, 249,0.61); color:#222222; padding:12px 20px; border-radius:30px; cursor:pointer; font-weight:700}

/* Responsive */
@media (max-width:1000px){

.ma-section{padding:60px 0px; }

  .ma-feat-ac-5ures{flex-direction:column; align-items:center}
  .ma-cta{flex-direction:column; gap:18px; text-align:center}
  .ma-cta-btn{align-self:center}
}
`}</style>
    </>
  );
}
